
import { parseTime } from '../utils'

export function parseTimeStr(time, str) {
    var timestamp = new Date(time).getTime()
    return parseTime(timestamp, str)
}
